import React from 'react';
import { Gear as Cog, Gauge, GasPump as Fuel, Drop as Droplet, Lightning as Zap, Leaf } from '@phosphor-icons/react';
import SpecCard from './SpecCard';
import { useTranslation } from '../../i18n/I18nContext';
import { translateValue } from '../print/translations';

const FALLBACK_VALUE = '—';

/**
 * 2x2 spec grid for the new-model landing (Autodis OMODA/JAECOO, issue #884).
 *
 * Slots are filled by priority so the grid always has 4 cards even if some
 * fields are missing on the car:
 *   1. Power            (always; falls back to em-dash)
 *   2. Fuel             (always; falls back to em-dash)
 *   3. Consumption  →   CO₂        (first present wins; em-dash if neither)
 *   4. Range        →   Transmission         (first present wins)
 *
 * Год машины убран по запросу клиента — машина 2025 года может стоять
 * в салоне в 2026/2027, выглядит как б/у и сбивает покупателя (см. Maria
 * 12.06 в Design chat + Tatyana подтвердила в звонке 15.06).
 *
 * @param {object} props
 * @param {object} props.car — Car object (DealerCarDto).
 */
const NewModelSpecsGrid = ({ car }) => {
  // Данные инвентаря лежат по-французски (Autodis Luxembourg) — гоним через
  // translateValue, чтобы спеки менялись вслед за выбранным языком (#1086).
  const { language } = useTranslation();
  const tr = (value) => translateValue(value, language);
  // key={`${car?.id}:<slot>`} remounts each SpecCard when the active car
  // changes, so the CSS fade-in keyframe on .landing__spec-card replays
  // and the values animate instead of blinking (#965 user feedback).
  const carId = car?.id;
  return (
    <div className="landing__specs-grid">
      <SpecCard key={`${carId}:power`} icon={Gauge} value={car.enginePower ? tr(car.enginePower) : FALLBACK_VALUE} />
      <SpecCard key={`${carId}:fuel`} icon={Fuel} value={car.fuelType ? tr(car.fuelType) : FALLBACK_VALUE} />
      {car.consumption ? (
        <SpecCard key={`${carId}:consumption`} icon={Droplet} value={tr(car.consumption)} />
      ) : car.co2Emissions ? (
        <SpecCard key={`${carId}:co2`} icon={Leaf} value={tr(car.co2Emissions)} />
      ) : (
        <SpecCard key={`${carId}:slot3-fallback`} icon={Leaf} value={FALLBACK_VALUE} />
      )}
      {car.range ? (
        <SpecCard key={`${carId}:range`} icon={Zap} value={tr(car.range)} />
      ) : (
        <SpecCard key={`${carId}:trans`} icon={Cog} value={tr(car.transmission)} />
      )}
    </div>
  );
};

export default NewModelSpecsGrid;
